'use strict';

export default ($window) => {
  'ngInject';

  return {
    doIt(URL) {
      $window.location.href = URL;
    }
  };
};



// WEBPACK FOOTER //
// ./app/src/services/reload_page.js